<template lang="pug">
</template>

<script>
export default {
  name: 'TableItemDetailModal'
}
</script>

<style>
</style>
